import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./CategoryTileCard.css";

export default function CategoryTileCard({ icon, label, serviceCount, ctaHref }) {
  return (
    <Link to={ctaHref} className="category-tile-card" aria-label={`${label} (${serviceCount} services)`}>
      <span className="ctc-icon" aria-hidden="true">{icon}</span>
      <span className="ctc-label">{label}</span>
      {typeof serviceCount === "number" && (
        <span className="ctc-count">({serviceCount} services)</span>
      )}
      <FaArrowRight className="ctc-arrow" aria-hidden="true" />
    </Link>
  );
}
